import React from "react";
import PropTypes from "prop-types";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const JustificationPanel = ({ reason }) => {
  if (!reason) return null;

  return (
    <div className="bg-card border border-card-bd rounded-card p-5">
      <div className="flex items-center gap-2 mb-4">
        <FontAwesomeIcon
          icon={icon({
            name: "file-lines",
            family: "sharp",
            style: "light",
          })}
          className="text-text-2 text-sm"
        />
        <h3 className="text-sm font-semibold text-text">Justification</h3>
      </div>

      <div className="max-h-48 overflow-auto text-sm text-text whitespace-pre-wrap leading-relaxed">
        {reason}
      </div>

      {/* TODO: render expected_duration once available from API */}
      {/* TODO: render supporting_context once available from API */}
    </div>
  );
};

JustificationPanel.propTypes = {
  reason: PropTypes.string,
};

export default JustificationPanel;
